import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'

import { connect } from 'react-redux'
import authActions from '../../redux/auth/actions'

class LoginRequireComponent extends Component {

    render() {
        if (!this.props.isLoggedIn)
            return (
                <Redirect
                    to={{
                        pathname: '/signin',
                        state: {
                            from: this.props.location,
                        },
                    }}
                />
            )

        return (
            <Route {...this.props} onEnter = {this.props.checkSession()}/>
        )
    }
}

const mapStateToProps = state => {
    return {
        isLoggedIn: state.auth.isLoggedIn,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        checkSession: () => {
            dispatch(authActions.action.checkSession())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginRequireComponent)
